// src/services/googleApiClient.js

import axios from "axios";
import { getAccessToken } from "../auth/tokenStorage";

/**
 * Creates an Axios instance preconfigured for Google API requests
 */
const googleApiClient = axios.create({
  baseURL: "https://sheets.googleapis.com/v4",
  headers: {
    "Content-Type": "application/json",
  },
});

/**
 * Request interceptor to inject OAuth2 access token
 */
googleApiClient.interceptors.request.use(
  (config) => {
    const token = getAccessToken(); // <-- replaced getToken() with getAccessToken()
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default googleApiClient;